import { render, staticRenderFns } from "./CustomerUpdateDefaultPaymentTypeDialog.vue?vue&type=template&id=79e8b9bb&scoped=true"
import script from "./CustomerUpdateDefaultPaymentTypeDialog.vue?vue&type=script&lang=ts"
export * from "./CustomerUpdateDefaultPaymentTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e8b9bb",
  null
  
)

export default component.exports